export const isInsideApp = () => {
  const isTWA = document.referrer.includes("android-app://com.solu.taskamoon");

  const isStandalone =
    window.matchMedia?.("(display-mode: standalone)")?.matches === true ||
    window.navigator.standalone === true;

  return isTWA || isStandalone;
};

export default isInsideApp;
